import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext(); // Named export

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "desertTitanium");

  useEffect(() => {
    console.log("Theme updated to:", theme);
    localStorage.setItem("theme", theme); // Persist selection
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
